module.exports = __webpack_public_path__ + "img/whxt.701f7ea0.png";